var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, ElementRef, EventEmitter, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { SelectableNavigationItem } from '../../model/selectable-navigation-item';
import { Router } from '@angular/router';
import { OmapiIdConstants } from '../../shared/omapi-id-constants';
import { PriceUtils } from '../../shared/utils/price/price.utils';
import { LanguageService } from '../../services/language/language.service';
import { TvshopConstants } from '../../shared/tvshop-constants';
import { Environment } from '../../shared/environment/environment';
import { NavigationService } from '../../services/navigation/navigation.service';
import { PageNames } from '../../shared/page-names.enum';
import { CarouselService } from '../../services/carousel/carousel.service';
import { takeUntil } from 'rxjs/operators';
import { TvShopEntertainmentPack } from '../../model/tv-shop-entertainment-pack';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
var CarouselItemComponent = /** @class */ (function (_super) {
    __extends(CarouselItemComponent, _super);
    function CarouselItemComponent(router, navigationService, changeDetector, languageService, renderer, carouselService, stateService) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.navigationService = navigationService;
        _this.changeDetector = changeDetector;
        _this.languageService = languageService;
        _this.renderer = renderer;
        _this.carouselService = carouselService;
        _this.stateService = stateService;
        _this.selectedCarouselItem = new EventEmitter();
        return _this;
    }
    CarouselItemComponent.prototype.ngOnInit = function () {
        this.navigationService.registerNavigation(this, PageNames.HOMEPAGE);
        this.appendInMemoryImage();
        this.shouldShowStreamzPromoBadge();
    };
    CarouselItemComponent.prototype.appendInMemoryImage = function () {
        var _this = this;
        this.carouselService.carouselImages$.pipe(takeUntil(this.stopSubscription)).subscribe(function (imageArray) {
            if (imageArray && _this.carouselImageWrapper && _this.omapiId) {
                _this.renderer.appendChild(_this.carouselImageWrapper.nativeElement, imageArray[_this.omapiId + '-item']);
            }
        });
    };
    CarouselItemComponent.prototype.activate = function (active) {
        this.active = active;
        if (this.active) {
            this.selectedCarouselItem.emit(this);
        }
        this.changeDetector.detectChanges();
    };
    CarouselItemComponent.prototype.onBack = function () {
        window.close();
    };
    CarouselItemComponent.prototype.onEnter = function () {
        this.stateService.setSelectedTvShopEntertainmentPack(this.pack);
        this.router.navigate(['/product-details/', this.omapiId], { queryParamsHandling: 'merge' });
    };
    CarouselItemComponent.prototype.shouldShowStreamzPromoBadge = function () {
        this.showStreamzPromoBadge = OmapiIdsUtils.STREAMZ_FREE_ADD_PACKS_GROUP.includes(this.pack.omapiId);
    };
    Object.defineProperty(CarouselItemComponent.prototype, "isTrialProduct", {
        get: function () {
            return this.pack.omapiId === OmapiIdConstants.TRIALS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselItemComponent.prototype, "hasPromo", {
        get: function () {
            return this.pack && this.pack.priceDetail && this.pack.priceDetail.hasPromo();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselItemComponent.prototype, "textIntegerPart", {
        get: function () {
            return this.pack && this.pack.priceDetail ? this.pack.priceDetail.price.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselItemComponent.prototype, "textDecimalPart", {
        get: function () {
            return this.getDecimalTextPart(this.pack && this.pack.priceDetail ? this.pack.priceDetail.price.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselItemComponent.prototype, "promoTextIntegerPrice", {
        get: function () {
            return this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoPrice.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselItemComponent.prototype, "promoTextDecimalPart", {
        get: function () {
            return this.getDecimalTextPart(this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoPrice.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselItemComponent.prototype, "promoLabel", {
        get: function () {
            return this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoLabel : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselItemComponent.prototype, "promoDuration", {
        get: function () {
            return this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoDuration : undefined;
        },
        enumerable: true,
        configurable: true
    });
    CarouselItemComponent.prototype.getDecimalTextPart = function (price) {
        return PriceUtils.prefixDecimalPart(price, this.currentLang);
    };
    Object.defineProperty(CarouselItemComponent.prototype, "currentLang", {
        get: function () {
            return this.languageService.getCurrentLanguage().toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselItemComponent.prototype, "isSizeOneClassNeeded", {
        get: function () {
            var logosNeedSizeOneClass = [
                OmapiIdsUtils.DISNEY_PLUS_ID,
                OmapiIdsUtils.BOUQUET_AFRICAIN_LEGACY_ID,
                OmapiIdsUtils.FAMILY_FUN_LEGACY_ID,
                OmapiIdsUtils.PASSION_XL_LEGACY_ID,
                OmapiIdsUtils.DISCOVER_MORE_LEGACY_ID,
                OmapiIdsUtils.TRIALS_LEGACY_ID
            ];
            var omapiId = this.pack && this.pack.omapiId || '';
            return logosNeedSizeOneClass.map(function (o) { return o.toLowerCase(); }).includes(OmapiIdsUtils.getCorrectIdForResource(omapiId).toLowerCase());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselItemComponent.prototype, "logoUrl", {
        get: function () {
            var baseUrl = Environment.environmentConfig() && Environment.environmentConfig().baseUrl;
            var url = baseUrl + TvshopConstants.CAROUSEL_LOGOS_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(this.pack.omapiId);
            var logoPostfix = this.isTrialProduct ? 'visual.png' : 'logo.png';
            return url + "-carousel-" + logoPostfix;
        },
        enumerable: true,
        configurable: true
    });
    CarouselItemComponent.prototype.isRedCarpetOrRedCarpetMore = function () {
        return (this.pack.omapiId === OmapiIdConstants.STREAMZ || this.pack.omapiId === OmapiIdConstants.RED_CARPET_MORE);
    };
    CarouselItemComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.carouselImageWrapper) {
            this.carouselImageWrapper.nativeElement = null;
        }
        this.carouselImageWrapper = null;
    };
    return CarouselItemComponent;
}(SelectableNavigationItem));
export { CarouselItemComponent };
